/* Wondr Light - product gallery, quantity steppers and cart quantity updates. Vanilla JS. */
(function () {
  'use strict';

  if (window.__wonderShop) return;
  window.__wonderShop = true;

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-wonder-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-wonder-gallery]');
      var index = thumb.getAttribute('data-wonder-thumb');
      if (!gallery) return;
      gallery.querySelectorAll('[data-wonder-slide]').forEach(function (slide) {
        slide.hidden = slide.getAttribute('data-wonder-slide') !== index;
      });
      gallery.querySelectorAll('[data-wonder-thumb]').forEach(function (button) {
        button.setAttribute('aria-current', button === thumb ? 'true' : 'false');
      });
      return;
    }

    var step = event.target.closest('[data-wonder-step]');
    if (step) {
      var wrapper = step.closest('[data-wonder-qty]');
      var input = wrapper && wrapper.querySelector('input');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-wonder-step'), 10);
      var min = parseInt(input.getAttribute('min'), 10);
      input.value = Math.max(isNaN(min) ? 0 : min, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* Cart page: submit the cart form when a quantity changes. */
  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-wonder-cart-qty] input');
    if (!input) return;
    var form = input.closest('form');
    if (!form) return;
    var flag = document.createElement('input');
    flag.type = 'hidden';
    flag.name = 'update';
    flag.value = 'Update';
    form.appendChild(flag);
    form.submit();
  });
})();